import React, { Component } from "react"
import Loading from "../Loading"

interface Props {
  loader: any
  [key: string]: any
}

/**
 * @author hz20126003
 * @date 2020-08-17
 * @param {any} loader 加载方法
 *  import Dynamic from '@/components/Dynamic';
 *   <Dynamic
 *      loader={}
 *   />
 */
export default class extends Component<Props, {}> {
  state: any = { Components: null }

  componentDidMount() {
    const { loader } = this.props
    loader()
      .then((res: any) => res.default)
      .then((Components: any) => {
        if (this.state) {
          this.setState({ Components })
        }
      })
  }
  render() {
    const { ...rest } = this.props
    const { Components } = this.state
    return Components ? <Components {...rest} /> : <Loading isloading={true} />
  }
}
